import { toast } from 'react-toastify';
import { all, put, takeLatest } from 'redux-saga/effects';
import api from '~/services/api';
import { callHandler } from '~/services/callWrapper';
import { getBoletimFailure, getBoletimSuccess } from './actions';

export function* getBoletim() {
  try {
    const response = yield callHandler(api.get, '/boletim');
    yield put(getBoletimSuccess(response.data));
  } catch (error) {
    yield put(getBoletimFailure());
    toast.error(
      'Falha ao tentar carregar o boletim, favor contactar o suporte.'
    );
  }
}

export default all([takeLatest('@boletim/REQUEST_BOLETIM', getBoletim)]);
